import { Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { NgxSpinnerService } from 'ngx-spinner';
import { CurrencySymbolConstant } from 'src/app/common/Constants/CurrencySymbolConstant';
import { REPORT_STATUS } from 'src/app/common/Constants/enums';
import { ApiUrlHelper } from 'src/app/common/api-url-helper';
import { CustomerReportStatusLabelConstant } from 'src/app/constants/LabelConstants';
import { dateformat } from 'src/app/models/commonModel';
import { CommonService } from 'src/app/services/common/common.service';

@Component({
    selector: 'app-report-status-modal',
    templateUrl: './report-status-modal.component.html',
    styleUrls: ['./report-status-modal.component.scss'],
    standalone: false
})
export class ReportStatusModalComponent {

  reportDetail: any = [];
  reportId: any;
  reportStatus: any;
  LabelConstant: any
  dateFormat: { datetime: string; titleFormat: string; date: string; shortTime: string; };
  currencySymbolConstant: { euroSign: string; percentageSign: string; };

  constructor(
    private dialogRef: MatDialogRef<ReportStatusModalComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any,
    private spinner: NgxSpinnerService,
    private api: ApiUrlHelper,
    private commonService: CommonService
  ) { }

  ngOnInit(): void {
    this.reportStatus = REPORT_STATUS;
    this.currencySymbolConstant = CurrencySymbolConstant;
    this.LabelConstant = CustomerReportStatusLabelConstant;
    this.dateFormat = dateformat;
    this.getReportDetail();
  }

  getReportDetail() {
    let api = this.api.apiUrl.Report.reportDetail;
    let reportDetailModel = {
      isRefundRequestDetail: false,
      reportRequestId: this.reportId
    };
    this.spinner.show();
    this.commonService.doPost(api, reportDetailModel).pipe().subscribe({
      next: (response: any) => {
        if (response.success) {
          this.reportDetail = response.data;
        }
        this.spinner.hide();
      },
      error: (err) => {
        this.spinner.hide();
        console.log(err);
      },
    });
  }

  cancel() {
    this.dialogRef.close();
  }
}
